import { format } from "date-fns";
import type { Locale } from "date-fns/locale";
import { fr } from "date-fns/locale";

/** YYYY-MM-DD from a TZ-agnostic UTC ISO calendar date (events). */
export function calendarDateFromIsoUtc(iso: string): string {
  const parsed = new Date(iso);
  if (isNaN(parsed.getTime())) return "";

  const y = parsed.getUTCFullYear();
  const m = String(parsed.getUTCMonth() + 1).padStart(2, "0");
  const d = String(parsed.getUTCDate()).padStart(2, "0");

  return `${y}-${m}-${d}`;
}

/** Today's calendar date in UTC (YYYY-MM-DD). */
export function todayUtcCalendarDateKey(): string {
  const now = new Date();
  const y = now.getUTCFullYear();
  const m = String(now.getUTCMonth() + 1).padStart(2, "0");
  const d = String(now.getUTCDate()).padStart(2, "0");

  return `${y}-${m}-${d}`;
}

export function startOfDayISO(dateStr: string): string {
  return `${dateStr}T00:00:00.000Z`;
}

export function endOfDayISO(dateStr: string): string {
  return `${dateStr}T23:59:59.999Z`;
}

/** Display a TZ-agnostic UTC calendar date without local timezone shift. */
export function formatEventCalendarDate(iso: string, locale: Locale = fr): string {
  const parsed = new Date(iso);
  if (isNaN(parsed.getTime())) return iso;

  const utcAsLocal = new Date(parsed.getUTCFullYear(), parsed.getUTCMonth(), parsed.getUTCDate());

  return format(utcAsLocal, "dd MMM yyyy", { locale });
}
